export default __webpack_public_path__ + "static/media/leader_notes.3e7885a1.pdf";